export const useState = (): SortState => {
  return {
    sortKey: 'abfahrt',
    sortOrder: 1
  }
}

export interface SortState {
  sortKey: string,
  sortOrder: number,
}